
import { observable, runInAction, toJS, action } from 'mobx';
import { message } from "antd";
import Echarts from "echarts";
import getJson, { numConvert } from "../../method";
import moment from "moment";

// 暖色调['#7079df', '#d15b7f', '#fb6e6c', '#ff9f69', '#feb64d', '#ffda43', '#ffe88e']
// 冷色调 ['#60acfc', '#23c2db', '#33d3eb', '#9cdc82', '#d4ec59', '#ffe168']
const color = ['#4A5BB9', '#F9BD5B', '#A8B0C9', '#8F98B3', '#C2BBD8', '#FFD590'];
const columnColor = ['#7079df', '#d15b7f', '#fb6e6c', '#ff9f69', '#feb64d', '#ffda43', '#ffe88e'];
const textStyle = {
    color: "#000",
    fontSize: 14
};
const titleColor = ['#4594B8', '#00536E', '#5DB8E5', '#8CD9FF'];
Number.prototype.toFixed = function (exponent) {
    if (this > 0) {
        return parseInt(this * Math.pow(10, exponent) + 0.5) / Math.pow(10, exponent);
    } else {
        return parseInt(this * Math.pow(10, exponent) - 0.5) / Math.pow(10, exponent);
    }
}

class store {
    @observable data = {};
    @observable score = [];
    @observable loading = true;
    /*
     *  rooms       客房数据 1：本月 2：本年 
     *  operating   每可用房经营收入
     *  income      1:收入分类 2：收入份额
     *  month       1 总收入  2 餐饮收入  
     *  day         1 总收入  2 餐饮收入   3 其他收入
    */
    @observable selectData = {
        rooms: 2,
        operating: 2,
        income: 1,
        month: 1,
        day: 1
    };

    @action
    getData = async (year, month, week) => {
        this.loading = true;
        try {
            let res = await fetch(`/bi_general?year=${year}&month=${month}&week=${week}`, { credentials: 'include' });
            let json = await res.json();
            const data = json.data || {};

            let resm = await fetch(`/getRoomsMonth?year=${year}&month=${month}&week=${week}`, { credentials: 'include' });
            let jsonm = await resm.json();

            const roomsLeft = {
                id: "room_left",
                dataY: (jsonm.data || []).map((x, i) => ({ name: x.name, data: Object.entries(x.data || {}).map(item => i >= 2 ? Number(item[1] * 100).toFixed(4) : Number(item[1]).toFixed(2)) })),
                dataX: ['Actual 实际', 'Forecast 预测', 'Budget 预算', 'Last Year 去年'],
                titleColor: ['#7079df', '#d15b7f', '#fb6e6c', '#ff8b4a'],
            }
            this.setRoomsLeft(roomsLeft);

            const roomsRight = {
                dataY: Object.entries(data.opera.total || {}).map(x => {
                    return (Number(data.opera.rooms[x[0]]) == 0 ? 0 : x[1] / data.opera.rooms[x[0]]).toFixed(2);
                })
            };

            this.setRoomRight(roomsRight);

            const foodLeft = {
                id: "food_left",
                title: "收入份额",
                dataSource: Object.entries(data.revenueShare || {}).map(x => ({ name: x[0], value: Number(x[1]).toFixed(2) }))
            };
            this.setPie(foodLeft, false, true);

            const foodRight = {
                id: "food_right",
                title: "占比",
                dataX: Object.entries(data.PlacingRate.MTD || {}).map(x => (x[0])),
                dataY: [{
                    name: "MTD",
                    type: "percent",
                    data: Object.entries(data.PlacingRate.MTD || {}).map(x => (numConvert(x[1] * 100).toFixed(2))),
                }, {
                    name: "YTD",
                    type: "percent",
                    data: Object.entries(data.PlacingRate.YTD || {}).map(x => (numConvert(x[1] * 100).toFixed(2))),
                }],
                yAxis: [
                    {
                        type: 'value',
                        name: '收入与成本占比',
                        axisLabel: {
                            formatter: '{value} %'
                        }
                    }
                ],
            };

            this.setRoomsLeft(foodRight);

            const score = (data.score.name || []).map((x, i) => ({
                name: x.name,
                ctrip: parseFloat(getJson([3, `col${i + 1}2`], data.score.data)),
                elong: parseFloat(getJson([4, `col${i + 1}2`], data.score.data)),
                book: parseFloat(getJson([5, `col${i + 1}2`], data.score.data)),
            }));

            const competitor_room = data.competitor_room;
            const staff_left = {
                id: "staff_left",
                dataX: Object.entries(competitor_room).map((x, i) => {
                    if (x[0].includes('酒店')) {
                        return `${i % 2 ? '' : '\n\n'}${x[0].split('酒店')[0]}酒店`
                    }

                    return x[0]
                }),
                dataY: [{
                    name: "平均房价 ADR",
                    data: Object.entries(competitor_room).map(x => x[1]['平均房价 ADR']),
                }, {
                    name: "Revpar",
                    data: Object.entries(competitor_room).map(x => x[1]['Revpar']),
                }, {
                    name: "入住率 Occ %",
                    data: Object.entries(competitor_room).map(x => {
                        return (x[1]['入住率 Occ'] || "").replace('%', '')
                    }),
                }],
                axisLabel: {
                    'interval': 0,
                    showMinLabel: true,
                    showMaxLabel: true,
                    // padding: [0, -10, 0, -10],
                    rotate: 0,
                    formatter: function (params, index) {
                        // 超出省略
                        params = params.toString();
                        var maxlength = 8;
                        if (index == 1) {
                            return params.substring(0, maxlength - 1) + '...';
                        }
                        return params;

                    }
                },
                yAxis: [
                    {
                        type: 'value',
                        name: '价格',
                        axisLabel: {
                            formatter: '{value}'
                        }
                    },
                    {
                        type: 'value',
                        name: '入住率',
                        max: 100,
                        axisLabel: {
                            formatter: '{value} %'
                        }
                    }
                ]
            };

            this.setRoomsLeft(staff_left);

            // 客房与员工数据
            const staffRight = {
                id: "staff_right",
                title: "",
                dataX: Object.entries(data.employee_output.room || {}).map((x, i) => ((i + 1) + "月")),
                dataY: [{
                    name: "客房部门",
                    data: Object.entries(data.employee_output.room || {}).map(x => (Number(x[1]).toFixed(2))),
                }, {
                    name: "餐饮部门",
                    data: Object.entries(data.employee_output.food || {}).map(x => (Number(x[1]).toFixed(2))),
                }, {
                    name: "其他部门",
                    data: Object.entries(data.employee_output.else || {}).map(x => (Number(x[1]).toFixed(2))),
                }]
            };
            this.setColumn(staffRight);

            const titleLeft = {
                dataX: Object.entries(data.Amount_occupancy || {}).map(x => (x[0] + '月')),
                dataY: Object.entries(data.Amount_occupancy || {}).map(x => (Number(x[1]))),
                id: "BI_title_left",
                name: "最高占用房数",
                titleColor
            }
            this.setTitleLeft(titleLeft);


            const titleRight = {
                dataX: Object.entries(data.ADR || {}).map(x => (x[0] + '月')),
                dataY: Object.entries(data.ADR || {}).map(x => (Number(x[1]))),
                id: "BI_title_right",
                name: "平均房价",
                titleColor
            }
            this.setTitleLeft(titleRight);

            const titleCenter = {
                titleColor,
                dataX: Object.entries(data.Occupancy || {}).map(x => (x[0] + '月')),
                dataY: Object.entries(data.Occupancy || {}).map(x => (Number((x[1] * 100).toFixed(2)))),
            };
            this.setTitleCenter(titleCenter);

            const listName = ['Electricity 电能 \n(KWH 千瓦时)', "Water 水 \n(m³ 立方)", 'Gas 燃气 \n(m³ 立方)'];
            const costData = Object.entries(data.cost || {}).map(x => {
                const arr = x[1].map((item, i) => ({ name: listName[i], value: Number(item).toFixed(2) }));
                return arr
            });

            this.setCostPie(costData);

            // 月度汇总
            const monthRooms = {
                id: "month-rooms",
                dataY: Object.entries(data.month.room || {}).map((x, i) => {
                    return {
                        name: x[0],
                        data: Object.entries(x[1]).map(item => numConvert(i == 2 ? 100 * item[1] : item[1]).toFixed(2))
                    }
                }),
            };
            this.setRoomsLeft(monthRooms);

            const monthRev = {
                id: "month-rev",
                labelShow: { show: false },
                dataY: Object.entries(data.month.rev || {}).map((x, index) => {
                    return Object.entries(x[1]).map((item,) => {
                        return {
                            name: `${index === 0 ? '月' : ""} ${item[0]}`,
                            value: numConvert(item[1]).toFixed(2),
                        }
                    })
                })
            };
            this.setCoolPie(monthRev);

            // 每日数据汇总
            // const dayRooms = {
            //     id: "day-rooms",
            //     dataX: Object.entries(data.day.room['arr'] || {}).map(x => `${x[0]}周`),
            //     dataY: [{
            //         name: "平均房价 ADR",
            //         data: Object.entries(data.day.room['arr'] || {}).map(x => numConvert(x[1])),
            //     }, {
            //         name: "Revpar",
            //         data: Object.entries(data.day.room['revpar'] || {}).map(x => numConvert(x[1])),
            //     }, {
            //         name: "入住率 Occ%",
            //         data: Object.entries(data.day.room['occ'] || {}).map(x => (x[1] * 100).toFixed(2)),
            //     }],
            //     titleColor,
            // };
            // this.setRoomsLeft(dayRooms);

            // const nameList = {
            //     food: "Food & Beverage 餐饮收入",
            //     other: 'Other Revenue 其他收入',
            //     room: "Rooms Revenue 客房收入"
            // };
            // const dayRev = {
            //     id: "day-rev",
            //     dataX: Object.entries(data.day.rev['food'] || {}).map(x => `${x[0]}周`),
            //     dataY: Object.entries(data.day.rev || {}).map(x => {
            //         return {
            //             name: nameList[x[0]],
            //             data: [...Object.entries(x[1]).map(item => item[1])]
            //         }
            //     }),
            //     titleColor,
            // };
            // this.setTotal(dayRev);

            runInAction(() => {
                this.score = score;
                this.data = data;
                this.loading = false;
            });

        } catch (error) {
            console.log(error);
            message.error('数据获取失败！');

            runInAction(() => {
                this.loading = false;
            });
        }

    }

    setCostPie = (data, isOnResize) => {
        const myChart = Echarts.init(document.getElementById('cost'));

        myChart.resize();
        if (isOnResize) {
            return
        }

        const option = {
            color,
            title: [{
                text: '客房区域能耗统计',
                x: '20%',
                y: '5%',
                textAlign: 'center'
            }, {
                text: '厨房区域能耗统计',
                x: '47%',
                y: '5%',
                textAlign: 'center'
            }, {
                text: '酒店总能耗统计',
                x: '77%',
                y: '5%',
                textAlign: 'center'
            }],
            textStyle,
            tooltip: {
                trigger: 'item',
                formatter: "{a} <br/>{b} {c} ({d}%)"
            },
            legend: [{
                orient: 'horizontal',
                left: '10%',
                top: '85%',
                width: '33%',
                data: data[0].map(x => x.name)
            }, {
                orient: 'horizontal',
                left: '40%',
                top: '85%',
                width: '33%',
                data: data[1].map(x => x.name)
            }, {
                orient: 'horizontal',
                left: '70%',
                top: '85%',
                width: '33%',
                data: data[2].map(x => x.name)
            }],
            series: [
                {
                    name: '客房区域能耗统计',
                    type: 'pie',
                    radius: '50%',
                    center: ["20%", '50%'],
                    data: data[0],
                    label: {
                        normal: {
                            textStyle: {
                                fontSize: 14
                            },
                            formatter: function (param) {
                                return param.name + ':\n' + param.percent + '%';
                            }
                        }
                    },
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                },
                {
                    name: '厨房区域能耗统计',
                    type: 'pie',
                    radius: '50%',
                    center: ["47%", '50%'],
                    data: data[1],
                    label: {
                        normal: {
                            textStyle: {
                                fontSize: 14
                            },
                            formatter: function (param) {
                                return param.name + ':\n' + param.percent + '%';
                            }
                        }
                    },
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                },
                {
                    name: '酒店总能耗统计计',
                    type: 'pie',
                    radius: '50%',
                    center: ["77%", '50%'],
                    data: data[0],
                    label: {
                        normal: {
                            textStyle: {
                                fontSize: 14
                            },
                            formatter: function (param) {
                                return param.name + ':\n' + param.percent + '%';
                            }
                        }
                    },
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                }
            ]
        };

        myChart.setOption(option);
    }

    setTitleCenter = (data, isOnResize) => {
        const { dataX, dataY, titleColor } = data;
        const myChart = Echarts.init(document.getElementById('BI_title_center'));

        myChart.resize();
        if (isOnResize) {
            return
        }
        const option = {
            tooltip: {
                trigger: 'axis',
                // formatter: `{b}<br/>{a} : {c}%`
            },
            color: titleColor || color,
            textStyle,
            calculable: true,
            grid: {
                left: 30,
                right: 30,
                bottom: 45
            },
            xAxis: [
                {
                    type: 'category',
                    boundaryGap: false,
                    show: false,
                    data: dataX,
                    axisLabel: {
                        // d
                        color: "black",
                        fontSize: 14
                    },
                }
            ],
            yAxis: {
                type: 'value',
                show: false,
            },
            series: [
                {
                    name: '入住率',
                    type: 'bar',
                    smooth: true,
                    barWidth: 10,
                    itemStyle: {
                        normal: {
                            areaStyle: { type: 'default' },
                            label: {
                                show: false,
                                formatter: function (p) {
                                    return p.value + '%';
                                }
                            }
                        }
                    },
                    data: dataY
                },
            ]
        };

        myChart.setOption(option);
    }

    setTitleLeft = (data, isOnResize) => {
        const { dataX, dataY, id, name, titleColor } = data;
        const myChart = Echarts.init(document.getElementById(id));
        myChart.resize();
        if (isOnResize) {
            return
        }

        const option = {
            tooltip: {
                trigger: 'axis'
            },
            color: titleColor || color,
            textStyle,
            calculable: true,
            grid: {
                left: 20,
                right: 20,
                bottom: 45
            },
            xAxis: [
                {
                    type: 'category',
                    boundaryGap: false,
                    show: false,
                    axisLabel: {
                        // d
                        color: "black",
                        fontSize: 14
                    },
                    data: dataX
                }
            ],
            yAxis: {
                type: 'value',
                show: false,
            },
            series: [
                {
                    name,
                    type: 'line',
                    smooth: true,
                    itemStyle: {
                        normal: { areaStyle: id === "BI_title_left" && { type: 'default' } }
                    },
                    data: dataY
                },
            ]
        };

        myChart.setOption(option);
    }

    setRoomsLeft = (data, isOnResize) => {
        const { dataX, dataY, id, titleColor, yAxis, axisLabel } = data;
        const myChart = Echarts.init(document.getElementById(id));
        myChart.resize();
        if (isOnResize) {
            return
        }
        const min = Math.min(...getJson([3, 'data'], dataY, [0])) || 0;
        const option = {
            color: titleColor || columnColor,
            textStyle,
            tooltip: {
                trigger: 'axis',
                axisPointer: { type: 'cross' },
            },
            grid: {
                top: 100,
            },
            legend: {
                data: dataY.map(x => x.name)
            },
            xAxis: [
                {
                    type: 'category',
                    axisLabel: {
                        color: "black",
                        fontSize: 14,
                        ...axisLabel
                    },
                    data: dataX || ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
                }
            ],
            yAxis: yAxis || [
                {
                    type: 'value',
                    name: '价格',
                    axisLabel: {
                        formatter: '{value}'
                    },
                    min

                },
                {
                    type: 'value',
                    name: '出租率',
                    axisLabel: {
                        formatter: '{value} %'
                    }
                }
            ],
            series: dataY.map((x, i) => {
                let yAxisIndex = i >= 2 ? 1 : 0;
                if (x.type === "percent") {
                    yAxisIndex = 0;
                }
                return {
                    name: x.name,
                    type: x.type && x.type != 'percent' ?
                        x.type : i >= 2 ?
                            'line' : "bar",
                    data: x.data.map(item => i % 2 ? `\n${item}` : item),
                    yAxisIndex,
                }
            }),
        }

        myChart.setOption(option);
    }


    setRoomRight = (data, isOnResize) => {
        const myChart = Echarts.init(document.getElementById('room_right'));
        const { dataY, dataX } = data;
        myChart.resize();
        if (isOnResize) {
            return
        }
        const option = {
            color: ['#48A7E5'],
            tooltip: {
                trigger: 'axis',
                axisPointer: { type: 'cross' }
            },
            textStyle,
            legend: {
                data: ['坪效']
            },
            xAxis: [
                {
                    type: 'category',
                    axisLabel: {
                        // d
                        color: "black",
                        fontSize: 14
                    },
                    data: dataX || ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
                }
            ],
            yAxis: [
                {
                    type: 'value',
                    name: '收入',
                    axisLabel: {
                        formatter: '{value}'
                    }
                },
            ],
            series: {
                name: '坪效',
                type: "bar",
                data: dataY,
            },
        }

        myChart.setOption(option);
    }

    setPie = (data, isOnResize, isClear) => {
        const { id, dataSource, title = "" } = data;
        const myChart = Echarts.init(document.getElementById(id));
        myChart.resize();
        if (isClear) {
            myChart.clear();
        }

        if (isOnResize) {
            return
        }
        const option = {
            color,
            textStyle,
            tooltip: {
                trigger: 'item',
                formatter: "{a} <br/>{b} : {c} ({d}%)"
            },
            legend: {
                data: dataSource.map(x => x.name)
            },
            series: [
                {
                    name: title,
                    type: 'pie',
                    radius: '50%',
                    center: ['50%', '60%'],
                    data: dataSource,
                    label: {
                        normal: {
                            textStyle: {
                                fontSize: 14
                            },
                            formatter: function (param) {
                                return param.name + ':\n' + param.percent + '%';
                            }
                        }
                    },
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                }
            ]
        };


        myChart.setOption(option);
    }

    setCoolPie = (data, isOnResize, isClear) => {
        const { id, dataX, dataY, title = "", labelShow = {} } = data;
        const myChart = Echarts.init(document.getElementById(id));
        myChart.resize();
        if (isClear) {
            myChart.clear();
        }

        if (isOnResize) {
            return
        }
        const option = {
            color: ['#8FA0FF', '#FFD590', '#D1D5E1', '#4A5BB9', '#F9BD5B', '#A8B0C9'],
            tooltip: {
                trigger: 'item',
                formatter: "{a} <br/>{b}: {c} ({d}%)"
            },
            legend: {
                data: dataX
            },
            textStyle,
            series: [
                {
                    name: '本月',
                    type: 'pie',
                    radius: [0, '30%'],
                    label: {
                        // normal: {
                        //     position: 'outer'
                        // },
                        show: true,
                        formatter: '{b}: {d}%',
                        ...labelShow
                    },
                    labelLine: {
                        normal: {
                            show: true,
                            ...labelShow
                        }
                    },
                    data: dataY[0],
                },
                {
                    name: '年累计',
                    type: 'pie',
                    radius: ['55%', '70%'],
                    label: {
                        show: true,
                        formatter: '{b}: {d}%',
                        ...labelShow
                    },
                    data: dataY[1],
                }
            ]
        };


        myChart.setOption(option);
    }


    setColumn = (data, isOnResize) => {
        let { id,
            dataX = [],
            dataY = [],
            tooltip
        } = data;
        const myChart = Echarts.init(document.getElementById(id));
        myChart.resize();
        if (isOnResize) {
            return
        }
        dataY = dataY.length <= 0 ? [{ name: "", data: [] }] : dataY;
        const option = {
            color: columnColor,
            textStyle,
            tooltip: {
                trigger: 'axis',
                axisPointer: { type: 'cross' },
                ...tooltip
            },
            legend: {
                data: dataY.map(x => x.name)
            },
            xAxis: [
                {
                    data: dataX,
                    axisLabel: {
                        // d
                        color: "black",
                        fontSize: 14,
                        align: "center",
                    },
                }
            ],
            yAxis: dataY.map(x => ({
                type: 'value',
                axisLabel: x.axisLabel || ""
            })),
            series: dataY.map(x => ({
                name: x.name,
                type: 'bar',
                data: x.data,
            }))
        }

        myChart.setOption(option);
    }

    setTotal = (data, isOnResize) => {
        let { id,
            dataX = [],
            dataY = [],
            tooltip = {},
            titleColor
        } = data;
        const myChart = Echarts.init(document.getElementById(id));
        myChart.resize();
        if (isOnResize) {
            return
        }

        const option = {
            color: titleColor || columnColor,
            textStyle,
            tooltip: {
                trigger: 'axis',
                axisPointer: { type: 'cross' },
                ...tooltip
            },
            grid: {
                left: 80,
            },
            legend: {
                data: ['Rooms Revenue 客房收入', 'Food & Beverage 餐饮收入', 'Other Revenue 其他收入']
            },
            xAxis: [
                {
                    data: dataX,
                    "type": "category",
                    "splitLine": {
                        "show": false
                    },
                    "axisTick": {
                        "show": false
                    },
                    "splitArea": {
                        "show": false
                    },
                    axisLabel: {
                        // d
                        color: "black",
                        fontSize: 14,
                        align: "center",
                    },
                }
            ],
            yAxis: [
                {
                    "type": "value",
                    "splitLine": {
                        "show": false
                    },
                    "axisTick": {
                        "show": false
                    },
                    "axisLabel": {
                        "interval": 0,
                    },
                    "splitArea": {
                        "show": false
                    },
                }
            ],
            series: [...dataY.map((x, i) => ({
                name: x.name,
                type: 'bar',
                stack: "总量",
                data: x.data,
            })), {
                "name": "总数",
                "type": "line",
                "itemStyle": {
                    "normal": {
                        "label": {
                            "show": true,
                            "textStyle": {
                                "color": "#333"
                            },
                            "top": -20,
                            formatter: function (p) {
                                const money = Math.abs(Number(p.value || "0")).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                                return p.value > 0 ? money : '';
                            }
                        }
                    }
                },
                data: dataY[0].data.map((x, i) => (numConvert(x) + numConvert(dataY[1].data[i]) + numConvert(dataY[2].data[i])).toFixed(2))
            }]
        }

        myChart.setOption(option);
    }

    onResize = () => {
        // 屏幕变化时自动适配
        this.setRoomsLeft({ id: "room_left" }, true);
        this.setRoomRight({}, true);
        this.setPie({ id: "food_left" }, true);
        this.setColumn({ id: "food_right" }, true);
        this.setRoomsLeft({ id: "staff_left" }, true);
        this.setColumn({ id: "staff_right" }, true);
        this.setTitleLeft({ id: "BI_title_left" }, true);
        this.setTitleLeft({ id: "BI_title_right" }, true);
        this.setTitleCenter({}, true);
        this.setCostPie({}, true);
        this.setRoomsLeft({ id: "month-rooms", }, true);
        this.setPie({ id: "month-rev", }, true);

        // this.setRoomsLeft({ id: "day-rooms" }, true);
        // this.setTotal({ id: "day-rev" }, true);
    }

    @action
    onChangeTime = async (name, value) => {
        const selectData = toJS(this.selectData);
        if (value == selectData[name]) return;
        selectData[name] = value;
        this.selectData = selectData;

        const data = toJS(this.data);
        switch (name) {
            case 'rooms':
                if (value == 2) {
                    const roomsLeft = {
                        id: "room_left",
                        dataY: (data.rooms || []).map((x, i) => ({ name: x.name, data: Object.entries(x.data || {}).map(item => i >= 2 ? Number(item[1] * 100).toFixed(4) : Number(item[1]).toFixed(2)) }))
                    }
                    this.setRoomsLeft(roomsLeft);
                } else {
                    let res = await fetch('/getRoomsMonth', { credentials: 'include' });
                    let json = await res.json();
                    const roomsLeft = {
                        id: "room_left",
                        dataY: (json.data || []).map((x, i) => ({ name: x.name, data: Object.entries(x.data || {}).map(item => i >= 2 ? Number(item[1] * 100).toFixed(4) : Number(item[1]).toFixed(2)) })),
                        dataX: ['Actual 实际', 'Forecast 预测', 'Budget 预算', 'Last Year 去年']
                    }
                    this.setRoomsLeft(roomsLeft);
                }
                break;
            case 'operating':
                if (value == 2) {

                    const roomsRight = {
                        dataY: Object.entries(data.opera.total || {}).map(x => {
                            return (Number(data.opera.rooms[x[0]]) == 0 ? 0 : x[1] / data.opera.rooms[x[0]]).toFixed(2);
                        })
                    };
                    this.setRoomRight(roomsRight);
                } else {
                    let res = await fetch('/getOperatingMonth', { credentials: 'include' });
                    let json = await res.json();

                    const roomsRight = {
                        dataY: Object.entries(json.data.total || {}).map(x => {
                            return (Number(json.data.rooms[x[0]]) == 0 ? 0 : x[1] / json.data.rooms[x[0]]).toFixed(2);
                        }),
                        dataX: ['Actual 实际', 'Forecast 预测', 'Budget 预算', 'Last Year 去年']
                    };
                    this.setRoomRight(roomsRight);
                }
                break;
            case 'income':
                if (value == 2) {
                    const foodLeft = {
                        id: "food_left",
                        title: "收入份额",
                        dataSource: Object.entries(data.revenueShare || {}).map(x => ({ name: x[0], value: Number(x[1]).toFixed(2) }))
                    };
                    this.setPie(foodLeft, false, true);
                } else {
                    const foodLeft = {
                        id: "food_left",
                        title: "收入份额",
                        dataX: (data.revenueSort || []).map(x => x.name),
                        dataY: (data.revenueSort || []).map(x => Number(x.value).toFixed(2)),
                    };
                    this.setColumn(foodLeft);
                }

                break;
            case 'month':
                if (value == 2) {
                    const monthRev = {
                        id: "month-rev",
                        dataSource: Object.entries(data.month.food || {}).map(x => ({ name: x[0], value: numConvert(x[1]) }))
                    };
                    this.setPie(monthRev, false, true);
                } else {
                    const monthRev = {
                        id: "month-rev",
                        dataSource: Object.entries(data.month.total || {}).map(x => ({ name: x[0], value: numConvert(x[1]) }))
                    };
                    this.setPie(monthRev, false, true);
                }

                break;

            default:
                break;
        }
    }
}

const revenue = new store();

export default revenue;


// WEBPACK FOOTER //
// ./src/store/BI/general.js